import { useTranslations } from '@fshr/context/i18n-context';
import { OverlayCarousel } from '../carousel/overlay-carousel';
import { ConversationCardData } from './types';
import { GlobalStoreType } from '@fshr/stores';
import { useMediaQuery } from 'react-responsive';
import { ConversationCardItem } from './conversation-data-card';

type ConversationCardsProps = {
	conversationCard?: ConversationCardData[];
	globalStore?: GlobalStoreType;
};

export function ConversationsCard(props: ConversationCardsProps) {
	const t = useTranslations();
	const { conversationCard, globalStore } = props;
	const isMobile = useMediaQuery({ maxWidth: 700 });

	// Return empty container, only welcome user will be shown
	if (!conversationCard?.length) {
		return null;
	}

	return (
		<section className="w-full grid gap-[10px] p-[20px] md:p-[30px]">
			<div className="w-full md:w-[490px] flex flex-col shadow-[0px_5px_15px_0px_rgba(3,3,3,0.12)] bg-surface-raised overflow-hidden">
				<h2 className="text-h4 text-text-heading pb-[15px] pt-[25px] px-[25px] md:pb-[20px] md:pt-[30px] md:px-[30px]">
					{globalStore?.profile?.firstName
						? t("Welcome {0}, we think you'll love this!", [globalStore?.profile?.firstName])
						: t("Welcome, we think you'll love this!")}
				</h2>
				<div className="w-full pb-[30px] px-[30px]">
					<OverlayCarousel
						disableButtons={false}
						buttonsType={isMobile ? ['rounded'] : ['rounded', 'arrow']}
						carouselItemsContainer="flex-row items-stretch"
						gap={15}
					>
						{conversationCard.map((card, index) => (
							<ConversationCardItem
								key={index}
								card={card}
								position={index + 1}
								placement="for_you-conversation_card_carousel"
								onClickNavigate={url => {
									if (url) window.location.href = url;
								}}
							/>
						))}
					</OverlayCarousel>
				</div>
			</div>
		</section>
	);
}
